import {
  VERIFY_ADDITIONAL_DATA,
  VERIFY_CALENDAR_OF_EVENTS,
  VERIFY_CHANNELS,
  VERIFY_PERFORMANCE_GOALS,
} from "@north-beam/nb-common";

export const WIZARD_STEPS_AUTOBLESSED_MODELS = [
  {
    title: "Basic Information",
    description: "Get started by selecting your name, dates, and model.",
    icon: <i className="fa-regular fa-pen-field" />,
  },
  {
    title: "Review and Create",
    description: `
      Please review all KPIs, channels, and linked custom inputs to confirm that everything is included for your upcoming cycle. Reach out to your representative for any changes.
      `,
    icon: <i className="fa-regular fa-list-check" />,
  },
];

export const DEPRECATED_WIZARD_STEPS = [
  {
    title: "Basic Information",
    description: "Get started by selecting your name, dates, and model.",
    icon: <i className="fa-regular fa-list" />,
  },
  {
    key: VERIFY_CHANNELS,
    title: "Channels",
    description:
      "Adding new channels takes time to get your model up and running.",
    icon: <i className="fa-regular fa-television" />,
  },
  {
    key: VERIFY_PERFORMANCE_GOALS,
    title: "Performance Goals",
    description: "Confirm these are the business goals you care about.",
    icon: <i className="fa-regular fa-bullseye-arrow" />,
  },
  {
    key: VERIFY_CALENDAR_OF_EVENTS,
    title: "Promotion Calendar",
    description: "Tell us your promotional periods so we can model correctly.",
    icon: <i className="fa-regular fa-calendar" />,
  },
  {
    key: VERIFY_ADDITIONAL_DATA,
    title: "Additional Data",
    description: "Please confirm that the rest of your data is up to date.",
    icon: <i className="fa-regular fa-tag" />,
  },
];
